<template>
    <div>
        <v-card flat>
            <v-card-title class="font-weight-bold text-h5 primary--text">
                Mis prestamos
            </v-card-title>

        </v-card>

    </div>
</template>

<script>

export default {
    data() {
        return {

        }
    }
}

</script>